import { ProjectsSettingsScreen } from '@mrrmlab/feature-day-planner';

export function EinstellungenProjekteRoute() {
  return <ProjectsSettingsScreen />;
}
